import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	jsmHelpMacroTitle: {
		id: 'company-hub.jsm-help-extension.manifest.macro-title',
		defaultMessage: 'JSM Help',
		description: 'Title of JSM help macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	jsmHelpMacroDescription: {
		id: 'company-hub.jsm-help-extension.manifest.macro-description',
		defaultMessage: 'Insert forms, articles, and resources from Jira Service Management',
		description:
			'Description of JSM help macro to be displayed in toolbar/shortcut macros dropdown',
	},
});
